/** Public, build-time configuration. Nothing here is secret; see eslint rule for VITE_ names. */
export const config = {
  apiBaseUrl:
    (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? 'http://localhost:7071/api',
} as const;
